import React from 'react';
import styles from './Partners.module.css';

const Partners: React.FC = () => {
  return (
    <section className={styles.section}>
      <h2 className={styles.title}>En partenariat avec</h2>
      <div className={styles.container}>
        <img
          src="/assets/images/sponsor-dataenso.png"
          alt="Data Enso"
          className={styles.logo}
        />
      </div>
    </section>
  );
};

export default Partners;
